import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TestcaseInteractionService {

  constructor() { }
  private executeApiSource = new Subject<string>();
  executeApi$ = this.executeApiSource.asObservable();

  executeApi(context: string) {
    this.executeApiSource.next(context);
  }
}
